import { render, staticRenderFns } from "./SSelectListsupplies.vue?vue&type=template&id=1715f9db"
import script from "./SSelectListsupplies.vue?vue&type=script&lang=js"
export * from "./SSelectListsupplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports